import gql from 'graphql-tag';

import { BPF_CHANGELOG_VIEW_MODEL_FRAGMENT } from './fragments';

export const GET_BPF_CHANGELOG_BY_ID = gql`
  ${BPF_CHANGELOG_VIEW_MODEL_FRAGMENT}
  query GetBpfChangelogById($input: BpfChangelogByIdInput!) {
    bpf {
      result: changelogById(input: $input) {
        success
        error
        entity {
          ...BpfChangelogViewModelFields
        }
      }
    }
  }
`;
